import { useEffect } from "react";
import { useProfile } from "@/context/ProfileContext";
import { useTheme } from "@/components/theme-provider";
import { isUiTheme } from "@/lib/ui-theme";

/**
 * Reconciles the visual theme (Classic/Lilac) with the user's profile
 * (GRA-142) once it loads, so a choice made on another device applies here
 * on reload without the user re-selecting it.
 *
 * Applies via the ThemeProvider's raw `setUiTheme` — local-only (localStorage
 * + DOM), no analytics and no write-back to the profile — so it can never
 * loop with the persist call in useChangeTheme.changeUiTheme. The pre-paint
 * script in index.html already applied the cached localStorage value before
 * first paint; this only catches up when the profile disagrees with it.
 */
export function UiThemeProfileSync() {
  const { memberProfile } = useProfile();
  const { uiTheme, setUiTheme } = useTheme();

  useEffect(() => {
    const saved = memberProfile?.uiTheme;
    if (isUiTheme(saved) && saved !== uiTheme) {
      setUiTheme(saved);
    }
  }, [memberProfile, uiTheme, setUiTheme]);

  return null;
}
